import { render, staticRenderFns } from "./IconReportPdf.vue?vue&type=template&id=52ffc965&"
var script = {}
import style0 from "./IconReportPdf.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/lasso/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52ffc965')) {
      api.createRecord('52ffc965', component.options)
    } else {
      api.reload('52ffc965', component.options)
    }
    module.hot.accept("./IconReportPdf.vue?vue&type=template&id=52ffc965&", function () {
      api.rerender('52ffc965', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/icons/IconReportPdf.vue"
export default component.exports